module.exports = __webpack_public_path__ + "media/images/emblems/Sulgen-Blazono--uff-1121b2c42c6e47dba9d339af6ae3cfa2.png";